import api from 'config/Api/Api';

const baseEndpoint = 'v1/incoming-call';

export default {
  getIncomingCalls( params ) {
    return api.get( baseEndpoint, params );
  },

  deleteSelectedIncomingCalls( data ) {
    return api.post( `${baseEndpoint}/mass-erase`, data );
  },
};
